export enum PlaceOrderErrorEnum {
  ORDER_HISTORY_PROCESSING_NOT_FINISHED = 'ORDER_HISTORY_PROCESSING_NOT_FINISHED'
}
